import { render, staticRenderFns } from "./PartialDetailsModal.vue?vue&type=template&id=61bcf4b5"
import script from "./PartialDetailsModal.vue?vue&type=script&lang=js"
export * from "./PartialDetailsModal.vue?vue&type=script&lang=js"
import style0 from "./PartialDetailsModal.vue?vue&type=style&index=0&id=61bcf4b5&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports